import { render } from "./LightningOrderImport.vue?vue&type=template&id=b8245268&scoped=true"
import script from "./LightningOrderImport.vue?vue&type=script&lang=js"
export * from "./LightningOrderImport.vue?vue&type=script&lang=js"

import "./LightningOrderImport.vue?vue&type=style&index=0&id=b8245268&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8245268"]])

export default __exports__